// extracted by mini-css-extract-plugin
export default {"header":"s_0t","description":"Y77l","split":"_2g6C","splitLeft":"_2s5q","splitRight":"_2N2j"};